import { faEdit, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import cn from 'classnames';
import { useForm } from 'hooks/useForm';
import { getNameInitials } from 'helpers/getNameInitials';
import { coachSchema } from 'constants/formValidationSchemas/coachSchema';
import { Tooltip } from 'components/Tooltip';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import styles from 'common/ProfileHeader/ProfileHeader.scss';

export const ProfileHeader = ({ entity, renderExtra = () => {}, onEntityNameUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, isValid, resetForm } = useForm(
    {
      initialValues: {
        surname: entity.surname,
        name: entity.name,
      },
      validationSchema: coachSchema,
      onSubmit: async (values) => {
        if (values.surname === entity.surname && values.name === entity.name) {
          setIsEditing(false);
          return;
        }

        await onEntityNameUpdate({ id: entity.id, ...values });
        setIsEditing(false);
      },
    }
  );

  useEffect(() => {
    if (!isEditing) {
      resetForm({
        values: {
          surname: entity.surname,
          name: entity.name,
        },
      });
    }
  }, [entity, isEditing]);

  const handleCancel = () => {
    setIsEditing(false);
    resetForm();
  };

  return (
    <div className={cn(styles.profile, { [styles.edit]: isEditing })}>
      <span className={styles.avatar}>{getNameInitials(entity)}</span>
      <div className={styles.info}>
        {isEditing ? (
          <form className={styles.form} onSubmit={handleSubmit}>
            <Input
              value={values.surname}
              name='surname'
              placeholder='Прізвище'
              errorText={touched.surname && errors.surname}
              invalid={touched.surname && !!errors.surname}
              onChange={handleChange}
              onBlur={handleBlur}
              className={styles.nameInput}
            />
            <Input
              value={values.name}
              name='name'
              placeholder="Ім'я"
              errorText={touched.name && errors.name}
              invalid={touched.name && !!errors.name}
              onChange={handleChange}
              onBlur={handleBlur}
              className={styles.nameInput}
            />
            <div className={styles.controls}>
              <Button
                text='Зберегти'
                type='submit'
                className={styles.button}
                disabled={
                  !isValid || isSubmitting || (values.surname === entity.surname && values.name === entity.name)
                }
                smallStyle
                no3D
              />
              <Button text='Скасувати' className={styles.button} onClick={handleCancel} ghostStyle smallStyle no3D />
            </div>
          </form>
        ) : (
          <>
            <span className={styles.name}>
              {entity.surname} {entity.name}
              <Button className={styles.editBtn} onClick={() => setIsEditing(true)} noStyle>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            </span>
            {renderExtra()}
            <div className={styles.row}>
              Борг:
              <span
                className={cn(styles.polarity, {
                  [styles.negative]: entity.debt > 0,
                })}
              >
                {entity.debt || 0}₴
              </span>
              <div className={cn(styles.additionalIcon, styles.debt)}>
                <FontAwesomeIcon icon={faInfoCircle} />
                <Tooltip
                  className={styles.debtInfo}
                  text='Значення боргу розраховується автоматично на основі неоплачених рахунків та не підлягає ручному редагуванню'
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
